import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  .container_integrator_steps {
    background-color: ${color.grey5};
    padding: 24px;
    border-radius: 12px;
    margin-bottom: 24px;
    .component_title_steps {
      margin-bottom: 20px;
    }
    .component_steps {
      .ant-steps-item-title {
        font-weight: 600;
        font-size: 16px;
        color: ${color.black4};
        &::after {
          height: 2px;
        }
      }
      .ant-steps-item-active .ant-steps-item-title {
        font-weight: 700;
        font-size: 16px;
        color: ${color.green1};
      }
      .ant-steps-item-finish .ant-steps-item-title {
        color: ${color.black1};
      }
    }
  }

  .component_integrator_steps_control {
    border-top: 1px solid ${color.grey1};
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
    padding-top: 24px;
  }
`;

export default Wrapper;
